import {createUseStyles} from 'react-jss'

export default createUseStyles({
  cardContainer: {
    width: 300,
    height: 243,
    margin: 10,
    backgroundColor: 'white',
    borderRadius: 5,
    boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
    color: 'rgba(0,0,0,0.85)',
    alignSelf: 'flex-start'
  },
  cardTop: {
    cursor: 'pointer',

    width: '100%',
    height: 80,
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
    textDecoration: 'none',
    color: 'rgba(0,0,0,0.85)',
    position: 'relative',
    '& > a': {
      position: 'absolute',
      width: "100%",
      height: '100%',
      top: 0
    }
  },
  topHeading: {
    width: '100%',
    height: '50%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px 0 20px',
    fontSize: 20,
    
  },

  botHeading: {
    width: '100%',
    height: '50%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: '5px 20px',
    fontSize: 13
  },
  cardContent: {
    display: '-webkit-box',
    margin: '10px 10px 0 10px',
    fontSize: 14,
    '-webkit-line-clamp': 7,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  dots: {
    fontSize: 20,
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.05)'
    },
    position: 'relative'
  },

 
})